import React from "react";
import safetyIcon from "@/assets/svgs/safety.svg";
import functionalityIcon from "@/assets/svgs/functionality.svg";
import verbrauchIcon from "@/assets/svgs/verbrauch.svg";
import issuesIcon from "@/assets/svgs/existing-issues.svg";
import Image from "next/image";

function Nutzen() {
  return (
    <div className="Nutzen">
      <div className="Nutzen-wrapper">
        <h2>Welche Informationen liefert die Fahrgestellnummer?</h2>
        <p>
          Die Fahrgestellnummer bietet eine Vielzahl an wichtigen Daten zu
          deinem Fahrzeug. <br className="desktop" /> Sie hilft dabei, die
          Geschichte und den Zustand des Autos besser zu verstehen,
          einschließlich:
        </p>

        <div className="Nutzen-infobox-main-wrapper">
          <div className="Nutzen-infobox-wrapper">
            <div className="Nutzen-infobox">
              <Image
                src={issuesIcon}
                alt="sicherheit"
                className="Nutzen-infobox-icon"
              />
              <h4>Fahrzeugdetails</h4>
              <ul>
                <li>
                  Technische Daten wie Motor, Getriebe, Farbe und Ausstattung.
                </li>
                <li>
                  Herstellungsland, Baujahr und ursprünglicher Listenpreis.
                </li>
              </ul>
            </div>
            <div className="Nutzen-infobox">
              <Image
                src={functionalityIcon}
                alt="sicherheit"
                className="Nutzen-infobox-icon"
              />

              <h4>Fahrzeughistorie</h4>
              <ul>
                <li>Anzahl der Vorbesitzer und sämtliche Registrierungen.</li>
                <li>Unfälle, Reparaturhistorie und Versicherungsfälle.</li>
              </ul>
            </div>
          </div>
          <div className="Nutzen-infobox-wrapper">
            <div className="Nutzen-infobox Nutzen-infobox-secondary">
              <Image
                src={safetyIcon}
                alt="sicherheit"
                className="Nutzen-infobox-icon"
              />
              <h4>Diebstahlüberprüfung</h4>
              <ul>
                <li>Abgleich, ob das Fahrzeug als gestohlen gemeldet ist.</li>
                <li>
                  Überprüfung in nationalen und internationalen Datenbanken.
                </li>
              </ul>
            </div>
            <div className="Nutzen-infobox Nutzen-infobox-secondary">
              <Image
                src={verbrauchIcon}
                alt="Wartungs- und Serviceinformationen"
                className="Nutzen-infobox-icon"
              />
              <h4>Wartungs- und Serviceinformationen</h4>
              <ul>
                <li>Übersicht zu durchgeführten Inspektionen und Wartungen.</li>
                <li>
                  Infos zu verpassten Intervallen und notwendigen Reparaturen.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Nutzen;
